exports.validator = function() {
	
	var validator = require('./validator');

	return validator;

}

exports.convert = function() {

	var convert = require('./convert');

	return convert;

}


//////////////////
// WEBPACK FOOTER
// ./node_modules/persianize/persianize.js
// module id = 748
// module chunks = 81